import React, {memo} from 'react';
import {UiDropdown} from '~/components/elements';
import {NamedProps} from 'react-select/src/Select';

interface Props {
  onChange: NamedProps['onChange'];
  trueLabel?: string;
  falseLabel?: string;
  includeAll?: boolean;
  defaultValue?: any;
  [key: string]: any;
}

const BooleanDropdown = ({
  trueLabel = 'Yes',
  falseLabel = 'No',
  includeAll = true,
  onChange,
  defaultValue = undefined,
  ...rest
}: Props) => {
  const defaultValueBoolean = {
    label: defaultValue ? trueLabel : falseLabel,
    value: defaultValue,
  };
  const options: {label: string; value: any}[] = [
    {label: trueLabel, value: true},
    {label: falseLabel, value: false},
  ];
  if (includeAll) {
    options.unshift({label: 'All', value: 'all'});
  }

  const onChangeLocal: NamedProps['onChange'] = (value, action) => {
    if (!onChange) {
      return null;
    }
    if (value?.value === 'all') {
      onChange(null, action);
    } else {
      onChange(value, action);
    }
  };
  let defaultSelectValue = undefined;
  if (defaultValue !== undefined) {
    defaultSelectValue = includeAll ? {label: 'All', value: 'all'} : defaultValueBoolean;
  }
  return (
    <UiDropdown
      defaultValue={defaultSelectValue}
      options={options}
      selection
      onChange={onChangeLocal}
      style={{minWidth: '7em'}}
      {...rest}
    />
  );
};

export default memo(BooleanDropdown);
